import React from 'react';

function Quote() {
  return (
    <section className="bg-[#CAD3D0] text-[#1A3C34] py-2 px-6 relative overflow-hidden pt-20"> {/* Changed background, added relative and overflow for decorative elements */}
      <div className="max-w-3xl mx-auto text-center relative z-10"> {/* Increased max-width for quote, added relative/z-index */}

        {/* Large Quote Marks - Conceptual approach to match image's large quote icon */}
        {/* This would ideally be a custom SVG or a font icon for better visual fidelity */}
        {/* For now, a simple text-based approach with heavy styling */}
        <p className="absolute -top-8 left-1/2 -translate-x-1/2 text-9xl font-serif text-[#1A3C34] opacity-70 z-0 select-none hidden md:block">
          “
        </p>
         <p className="absolute -bottom-8 right-1/2 translate-x-1/2 text-9xl font-serif text-[#1A3C34] opacity-70 z-0 select-none hidden md:block">
          ”
        </p>

        {/* Circular Badge - Placeholder for the element on the left side of the quote */}
        {/* This would be a separate component or an image in a real application */}
        <div className="absolute top-1/2 left-4 -translate-y-1/2 w-24 h-24 bg-[#1A3C34] opacity-70 rounded-full flex items-center justify-center shadow-lg hidden md:flex">
        </div>


        {/* Main Quote Text */}
        <p className="text-xl md:text-5xl font-medium leading-relaxed md:leading-tight relative z-20"> {/* Increased font size and line height */}
          "Our plant’s journey isn’t just about surviving;{' '}
          <span className="font-bold italic text-[#3C2415] [text-shadow:2px_2px_0px_rgba(246,241,225,0.7)]">
  it’s about thriving, growing stronger, and bringing life and beauty
</span>
         {' '} into your space."
        </p>

        {/* Optional: Author/Attribution below the quote */}
        <p className="mt-6 text-lg font-semibold text-[#1A3C34]">
          — ATX Plant Rescue
        </p>

      </div>
    </section>
  );
}

export default Quote;